import React, { FC } from 'react';
import styles from './RoundProfilePicture.module.css';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';

export interface RoundProfilePictureProps {
    icon?: string;
    src?: string;
    labelText?: string;
    hintText?: string;
    variant?: 'default' | 'edit';
}

export const RoundProfilePicture: FC<RoundProfilePictureProps> = ({ icon, src, labelText, hintText, variant = 'default' }) => {
    return (
        <div className={`d-flex flex-column align-items-center ${styles['round-icon-container']}`}>
            <div className={`${styles['round-icon']} position-relative`} data-testid="round-icon">
                {src ? (
                    <img src={src} alt="Profile" className={styles['round-icon-img']} />
                ) : (
                    <Typography tagVariant={TypographyTagVariants.span}>{icon && <i className={icon} />}</Typography>
                )}

                {variant === 'edit' && (
                    <div className={styles['edit-indicator']}>
                        <span className={styles['edit-plus']}>+</span>
                    </div>
                )}
            </div>

            {labelText && (
                <Typography align="center" fontSize="24" fontWeight="700" tagVariant={TypographyTagVariants.strong}>
                    {labelText}
                </Typography>
            )}

            {hintText && (
                <Typography align="center" fontSize="16" fontWeight="300" color="muted" tagVariant={TypographyTagVariants.span}>
                    {hintText}
                </Typography>
            )}
        </div>
    );
};
